import template from './search.html';
import controller from './search.controller';

const searchStoreComponent = {
  bindings: {
    onCancel: '&',
  },
  template,
  controller
};

export default searchStoreComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/storeSelect/search/search.component.js
 **/